










import { Component, Vue, Ref, Watch } from "vue-property-decorator";
@Component({
  name: "Home"
})
export default class Home extends Vue {
  logoPath: any = require("../assets/img/logo.jpg");
}
